@for (column of columns(); track column) {
    <td class="custom-table-td">
        @switch (column.field) {
            @case (dashboardColumnsEnum.ORDER_NAME) {
                <div>
                    <a
                        tooltipFocusHandler
                        [routerLink]="orderAbstractRoute()"
                        (click)="logOrderNameClick()"
                        (keydown.enter)="logOrderNameClick()">
                        <app-ellipsis-tooltip
                            [isElementFocusable]="false"
                            [paragraphId]="'order-list-order-name-' + order().id"
                            class="order-list-order-name">
                            {{ order().orderName }}
                        </app-ellipsis-tooltip>
                    </a>
                </div>
            }
            @case (dashboardColumnsEnum.STATUS) {
                <div class="center-td-content">
                    <app-order-status [status]="order().status"></app-order-status>
                </div>
            }
            @case (dashboardColumnsEnum.REQUESTER) {
                <div>
                    <app-ellipsis-tooltip [paragraphId]="'order-list-requester-' + order().id">
                        {{ order().requester }}
                    </app-ellipsis-tooltip>
                </div>
            }
            @case (dashboardColumnsEnum.NUMBER_OF_REACTIONS) {
                <div class="center-td-content">
                    <p [id]="'order-list-number-of-reactions-' + order().id">
                        {{ order().numberOfReactions }}
                    </p>
                </div>
            }
            @case (dashboardColumnsEnum.DATE_CREATED) {
                <div class="center-td-content">
                    <p [id]="'order-list-date-created-' + order().id">
                        {{ order().dateCreated ? (order().dateCreated | date: 'MM/dd/YYYY | HH:mm:ss') : '-' }}
                    </p>
                </div>
            }
        }
    </td>
}
